import styled from "styled-components"
import { up } from "styled-breakpoints"

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 20px;
  color: var(--selected-color);
`

const TextBox = styled.div`
  display: flex;
  flex-direction: column;

  strong {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 1.6rem;
    line-height: 1.9rem;

    ${up("md")} {
      font-size: 2.1rem;
      line-height: 2.5rem;
    }
  }

  span {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 1.2rem;
    line-height: 1.4rem;

    ${up("md")} {
      font-size: 1.8rem;
      line-height: 21px;
    }
  }
`

const PreviewHelper = () => {
  return (
    <Container>
      <img
        width={50}
        src="/assets/go-bags/upload-overlay.png"
        alt="upload logo icon"
      />
      <TextBox>
        <strong className="text-center">Click to upload</strong>
        <span className="text-center">(PNG and JPEG files only)</span>
      </TextBox>
    </Container>
  )
}

export default PreviewHelper
